(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[916],{

/***/ 49081:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[insuranceType]",
      function () {
        return __webpack_require__(1539);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _src_client_pages_insurance_content__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41992);
/* harmony import */ var _src_client_pages_insurance_utils_combine_content_with_cms_data__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70033);
/* harmony import */ var _src_client_ahm_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10453);
/* harmony import */ var _src_client_utils_get_should_skip_client_side_request__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14033);
/* harmony import */ var _src_client_pages_insurance__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66775);
/* harmony import */ var _src_client_utils_redirect_adapter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18971);
/* harmony import */ var _src_client_pages_insurance_hooks_use_get_insurance_type__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52646);









var URLS = _src_client_ahm_constants__WEBPACK_IMPORTED_MODULE_4__/* ["default"].URLS */ .Z.URLS;
var LandingPage = function(param) {
    var content = param.content, insuranceType = param.insuranceType;
    var shouldSkip = (0,_src_client_utils_get_should_skip_client_side_request__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    // refetch content for time travel
    var ref = (0,_src_client_pages_insurance_hooks_use_get_insurance_type__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        insuranceType: insuranceType,
        shouldSkip: shouldSkip
    }), clientSideCmsData = ref.data, hasError = ref.hasError, isLoading = ref.isLoading;
    if (hasError) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_client_utils_redirect_adapter__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            to: URLS.SALES.ERROR_500
        });
    }
    var staticContent = (0,_src_client_pages_insurance_content__WEBPACK_IMPORTED_MODULE_2__/* .getContent */ .L)(insuranceType);
    var combinedContent = shouldSkip ? content : (0,_src_client_pages_insurance_utils_combine_content_with_cms_data__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        cmsData: clientSideCmsData,
        staticContent: staticContent
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_client_pages_insurance__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        insuranceType: insuranceType,
        content: isLoading ? content : combinedContent
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (LandingPage);


/***/ }),

/***/ 3513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46829);
/* harmony import */ var _cms_queries__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56544);
/* harmony import */ var _cms_utils_unique_content_with_draft_precedence__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92002);



var useGetLatestArticles = function(param) {
    var options = param.options;
    var type = (options.variables || {}).type;
    var queryToFetch = type ? _cms_queries__WEBPACK_IMPORTED_MODULE_0__/* .GET_LATEST_BLOG_POSTS_BY_TYPE */ .Mn : _cms_queries__WEBPACK_IMPORTED_MODULE_0__/* .GET_LATEST_BLOG_POSTS */ .xs;
    var ref = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__.useQuery)(queryToFetch, options), data = ref.data, isLoading = ref.loading, error = ref.error;
    var articles = (0,_cms_utils_unique_content_with_draft_precedence__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(data === null || data === void 0 ? void 0 : data.allArticle);
    return {
        data: articles,
        error: error,
        isLoading: isLoading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetLatestArticles);


/***/ }),

/***/ 52646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ use_get_insurance_type; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/client/pages/insurance/queries/index.ts
var queries = __webpack_require__(44928);
// EXTERNAL MODULE: ./pages/utils/get-products-by-type/index.ts
var get_products_by_type = __webpack_require__(53754);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/client/cms/client/index.ts + 6 modules
var client = __webpack_require__(6465);
;// CONCATENATED MODULE: ./src/client/cms/client/utils/make-client-query/index.ts


/* 
Make a query to sanity without the use of the useQuery hook. The function matches the signature 
of the useQuery hook. 
*/ var makeClientQuery = function(query, options) {
    var sanityClient = client/* default.get */.Z.get();
    // @ts-expect-error - Automatic, Please fix when editing this file
    return sanityClient.query((0,_object_spread/* default */.Z)({
        query: query
    }, options)).then(function(response) {
        return response.data;
    });
};
/* harmony default export */ var make_client_query = (makeClientQuery);

// EXTERNAL MODULE: ./src/client/pages/blog-detail/hooks/use-get-latest-articles/index.ts
var use_get_latest_articles = __webpack_require__(3513);
// EXTERNAL MODULE: ./node_modules/@apollo/client/index.js
var _apollo_client = __webpack_require__(46829);
// EXTERNAL MODULE: ./src/client/cms/utils/unique-content-with-draft-precedence/index.ts
var unique_content_with_draft_precedence = __webpack_require__(92002);
;// CONCATENATED MODULE: ./src/client/pages/insurance/hooks/use-insurance-type-query/index.ts



var useInsuranceTypeQuery = function(gqlQuery, options) {
    var ref = (0,_apollo_client.useQuery)(gqlQuery, options), data = ref.data, loading = ref.loading;
    var content = (0,fp.head)((0,unique_content_with_draft_precedence/* default */.Z)(data === null || data === void 0 ? void 0 : data.allInsuranceType));
    return {
        data: content,
        loading: loading
    };
};
/* harmony default export */ var use_insurance_type_query = (useInsuranceTypeQuery);

;// CONCATENATED MODULE: ./src/client/pages/insurance/hooks/use-get-insurance-type/index.ts









var AMOUNT_OF_ARTICLES = 3;
var useGetInsuranceType = function(param) {
    var insuranceType = param.insuranceType, shouldSkip = param.shouldSkip;
    var ref = (0,react.useState)(null), products = ref[0], setProducts = ref[1];
    var ref1 = (0,react.useState)(null), allInsuranceTypeData = ref1[0], setAllInsuranceTypeData = ref1[1];
    var ref2 = (0,react.useState)(false), isLoadingProducts = ref2[0], setIsLoadingProducts = ref2[1];
    var ref3 = (0,react.useState)(false), hasError = ref3[0], setHasError = ref3[1];
    var ref4 = use_insurance_type_query(queries/* GET_INSURANCE_TYPE_QUERY */.FW, {
        skip: shouldSkip || !(0,fp.isEmpty)(allInsuranceTypeData),
        variables: {
            id: insuranceType
        }
    }), insuranceTypeData = ref4.data, isLoadingInsuranceType = ref4.loading;
    var ref5 = (0,use_get_latest_articles/* default */.Z)({
        options: {
            skip: shouldSkip,
            variables: {
                limit: AMOUNT_OF_ARTICLES,
                type: insuranceType
            }
        }
    }), articles = ref5.data, isLoadingArticles = ref5.isLoading;
    (0,react.useEffect)(function() {
        if (shouldSkip) {
            return;
        }
        var fetchProducts = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var productsByType, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsLoadingProducts(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                (0,get_products_by_type/* default */.Z)({
                                    client: make_client_query,
                                    type: insuranceType
                                })
                            ];
                        case 2:
                            productsByType = _state.sent();
                            setProducts(productsByType);
                            return [
                                3,
                                5
                            ];
                        case 3:
                            error = _state.sent();
                            setHasError(true);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            setIsLoadingProducts(false);
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchProducts() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchProducts();
    }, [
        insuranceType
    ]);
    (0,react.useEffect)(function() {
        if (insuranceTypeData && products && articles) {
            var insuranceDataToSet = (0,fp.flow)((0,fp.set)("articles", articles), (0,fp.set)("productsByType", products))(insuranceTypeData);
            setAllInsuranceTypeData(insuranceDataToSet);
        }
    }, [
        products,
        insuranceTypeData,
        articles
    ]);
    var isLoading = isLoadingInsuranceType || isLoadingProducts || isLoadingArticles;
    return {
        data: allInsuranceTypeData,
        hasError: hasError,
        isLoading: isLoading
    };
};
/* harmony default export */ var use_get_insurance_type = (useGetInsuranceType);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9392,3666,603,9149,8093,9774,2888,179], function() { return __webpack_exec__(49081); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);